<template>
    <div class="rules"
    :style="{
            background: `linear-gradient(180deg, ${colors[colors.theme].to}   0%,  ${colors[colors.theme].from} 100%)`,
            color: colors.theme == 'dark' ? `#fff` : `#000`
        }">
        <navbar :showScore="false"></navbar>
        <div class="rules-container">
            <div class="title-rules">
                <h1 class="title" v-show="!video_rules" :style="{'color' : colors.theme == 'dark' ? `#fff` : `#000`}">
                    {{ $t("views.rules.title-rules.title") }}
                </h1>
                <span class="regras">{{$t("views.rules.title-rules.regras")}}</span>
            </div>
            <div class="video_rules" v-show="video_rules">
                <iframe
                    width="100%"
                    height="100%"
                    :src="videoUrl"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
            </div>
            <div class="text-rules" v-show="!video_rules">
                <div class="rule" :style="{'color' : colors.theme == 'dark' ? `#fff` : `#000`}">
                    <p>{{ $t("views.rules.text-rules.p") }}!</p>
                    <span
                        ><strong>{{$t("views.rules.text-rules.strong1" )}} </strong> 
                        {{$t("views.rules.text-rules.span1" )}}
                        <strong>{{$t("views.rules.text-rules.strong2")}} </strong> {{ $t("views.rules.text-rules.span2") }}</span>
                </div>
                <ul>
                    <li>
                        {{$t("views.rules.text-rules.li1.span1")}} <strong>{{$t("views.rules.text-rules.li1.strong1")}}</strong>{{$t("views.rules.text-rules.li1.span2")}}
                        <strong>{{$t("views.rules.text-rules.li1.strong2")}}</strong> {{$t("views.rules.text-rules.li1.span3")}} <strong>{{$t("views.rules.text-rules.li1.strong3")}}</strong>
                    </li>
                    <li>
                        {{$t("views.rules.text-rules.li2.span1")}} <strong>{{ $t("views.rules.text-rules.li2.strong1") }}</strong> {{$t("views.rules.text-rules.li2.span2")}}
                        <strong>{{$t("views.rules.text-rules.li2.strong2")}}</strong> {{$t("views.rules.text-rules.li2.span3")}} <strong>{{ $t("views.rules.text-rules.li2.strong3")}}</strong>
                    </li>
                    <li>
                        {{$t("views.rules.text-rules.li3.span1")}} <strong>{{$t("views.rules.text-rules.li3.strong1")}}</strong> {{$t("views.rules.text-rules.li3.span2")}}
                        <strong>{{$t("views.rules.text-rules.li3.strong2")}}</strong>
                    </li>
                    <li>
                        {{$t("views.rules.text-rules.li4.span1")}} <strong>{{$t("views.rules.text-rules.li4.strong1")}}</strong>, {{ $t("views.rules.text-rules.li4.span2")}} <strong>{{$t("views.rules.text-rules.li4.strong2")}}</strong>
                    </li>
                    <li>
                        {{$t("views.rules.text-rules.li5.span1")}}<strong>{{$t("views.rules.text-rules.li5.strong1")}}</strong> {{$t("views.rules.text-rules.li5.span2")}}
                        <strong>{{$t("views.rules.text-rules.li5.strong2")}}</strong>
                    </li>
                    <li>
                        {{$t("views.rules.text-rules.li6.span1")}} <strong>{{$t("views.rules.text-rules.li6.strong1")}}</strong> {{$t("views.rules.text-rules.li6.span2")}}
                        <strong>{{$t("views.rules.text-rules.li6.strong2")}}</strong>
                    </li>
                </ul>
            </div>
            <div
                class="acceptance_button"
                @click="next"
                :class="{ disabled: isBtnDisabled }"
                :style="{
                    background: colors.secondary,
                    color: '#fff'
                }"
            >
                <span>{{ buttonText }}</span>
                <div class="arrow-right"
                :style="{
                    borderLeft: '6px solid #fff'
                }"
                ></div>
            </div>
        </div>
    </div>
</template>
<script>
import Navbar from "../components/shared/header/Navbar";
// import ButtonNext from '../components/shared/report/ButtonNext'
export default {
    components: {
        Navbar
        // ButtonNext
    },
    data() {
        return{
            videoRulesUrls: {
                "pt-br": 'https://www.youtube.com/embed/VaCu-Jw7-u8?mute=1',
                "en-us": 'https://www.youtube.com/embed/ES20X5GqfKg',
                "es": 'https://www.youtube.com/embed/ES20X5GqfKg'
            },
            videoUrl: '',
            checked: false,
            video_rules: true,
            video_height: "",
            buttonText: this.$t("views.rules.button_text1"),
            isBtnDisabled: true,
            colors: {}
        }
    },

    created() {
        this.colors = JSON.parse(localStorage.getItem("colors"));
        var self = this;
        self.video_height = window.outerHeight / 2;
        setTimeout(() => {
            return (self.isBtnDisabled = false);
        }, 3000);
    },
    mounted(){
        this.videoUrl = this.videoRulesUrls[localStorage.getItem('language').toLowerCase()]
    },

    methods: {
        next() {
            if (this.video_rules) {
                if (!this.isBtnDisabled) {
                    this.video_rules = !this.video_rules;
                    this.buttonText = `${this.$t("views.rules.button_text2")}`;
                }
                return `${this.$t("views.rules.button_text1")}`;
            }
            this.$router.push("/");
        }
    }
};
</script>
<style lang="scss" scoped>
.rules {
    height: 100%;
    display:flex;
    flex-direction:column;
    .rules-container {
        height: calc(100% - 55px);
        display: flex;
        flex-direction: column;
        // justify-content: space-evenly;
        position: relative;
        //padding: 40px 0;
        overflow: auto;
        gap: 2em;
        margin-top: 2em;

        .title-rules {
            //height: 20%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            // padding-bottom: 1em;

            .title,
            .regras {
                text-transform: uppercase;
                font-weight: bold;
                letter-spacing: 3px;
            }

            .title {
                font-size: 14px;
                text-align: center;
            }

            .regras {
                font-size: 35px;
                margin-top: 5px;
            }
        }
        .video_rules{
            flex: 1;
        }

        .text-rules {
            //height: 100%;
            display: flex;
            flex-direction: column;
            margin-top: 1em;
            padding: 0 32px;

            ul {
                padding-left: 32px;
                li {
                    list-style-type: disc;
                    padding: 5px;
                    font-size: 14px;

                    strong {
                        font-weight: 700;
                    }
                }
            }
            .rule {
                width: 85%;
                margin: 0 auto 75px;
                color: #666666;
                font-size: 18px;
                text-align: center;
                font-weight: 700;

                span {
                    font-size: 15px;
                }
            }
        }

        .button-play {
            position: fixed;
            bottom: 0;
            width: 100%;
        }
        .acceptance_button {
            // display: flex;
            // align-items: center;
            // text-align: center;
            // height: 10vh;
            // color: #000;
            // font-weight: 700;
            // text-decoration: none;
            // background-color: #fff581;
            // position: absolute;
            // width: 100%;
            // bottom: 0;
            transition: background 0.5s, color 0.5s, opacity 0.7s;
            display: flex;
            align-items: center;
            text-align: center;
            color: #000;
            font-weight: 700;
            text-decoration: none;
            width: 300px;
            margin: 1em auto 1.5em;
            border-radius: 300px;
            padding: 23px 0;

            span {
                font-size: 15px;
                letter-spacing: 2px;
                text-transform: uppercase;
                width: 90%;
                position: relative;
                left: 15px;        
            }

            .arrow-right {
                width: 0;
                height: 0;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 6px solid #000;
                width: 10%;
            }
        }

        .acceptance_button.disabled {
            opacity: 0.2;
            background: #2f353a94;
            color: #fff;
        }
    }
}

@media only screen and (min-width: 600px) {
    .rules {
        .rules-container {
            gap: 3em;
            margin-top: 3em;
            // justify-content: space-around;
            .title-rules {
                .title {
                    font-size: 19px;
                }

                .regras {
                    font-size: 55px;
                }
            }

            .text-rules {
                padding: 0 150px;
                .rule {
                    font-size: 20px;
                    margin: 0 auto 24px;
                }
            }

            .button-play {
                height: 10%;
                position: inherit;
            }
        }
    }
}
@media only screen and (max-width: 400px) {
    .rules {
        .rules-container {

            .text-rules {
                height: auto;
                .rule {
                    margin: 0 auto 24px;
                }
            }
        }
    }
}
</style>
